import Updater from "./Updater";

export const globalEchangesUpdater = new Updater();
